import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { SITE_PHOTOS } from '../data/sitePhotos';

const HIGHLIGHTS = [
  {
    title: 'Residential Moving',
    text: 'Apartments, condos, houses and senior moves, handled with care by licensed and insured movers.',
    to: '/services/residential-moving',
    photo: SITE_PHOTOS.residentialMoving,
  },
  {
    title: 'Packing & Moving Support',
    text: 'Full or partial packing, loading and unloading help, and moving supplies so you can focus on the rest of your move.',
    to: '/services/moving-support',
    photo: SITE_PHOTOS.packing,
  },
  {
    title: 'House Cleaning',
    text: 'Move-in and move-out cleaning, deep cleaning and recurring visits that leave your space spotless.',
    to: '/services/residential-cleaning',
    photo: SITE_PHOTOS.residentialCleaning,
  },
  {
    title: 'Commercial & Office Cleaning',
    text: 'Daily, weekly and medical-office cleaning for storefronts, offices and other business spaces.',
    to: '/services/commercial-cleaning',
    photo: SITE_PHOTOS.commercialCleaning,
  },
];

export const ServiceHighlights = () => {
  const goToBooking = () => {
    const element = document.getElementById('booking');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 sm:py-20 bg-white" aria-labelledby="service-highlights-heading">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 id="service-highlights-heading" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Everything You Need for a Smooth Move
          </h2>
          <p className="text-lg text-gray-600">
            Professional movers and cleaners for homes and businesses across Indiana.
          </p>
        </div>

        <div className="space-y-12 sm:space-y-16">
          {HIGHLIGHTS.map((item, index) => (
            <div
              key={item.title}
              className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12"
            >
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <img
                  src={item.photo.src}
                  alt={item.photo.alt}
                  width={item.photo.width}
                  height={item.photo.height}
                  loading="lazy"
                  decoding="async"
                  className="w-full rounded-2xl object-cover shadow-lg aspect-[4/3]"
                />
              </div>
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-lg text-gray-700 mb-6">{item.text}</p>
                <div className="flex flex-wrap gap-3">
                  <Button asChild className="bg-navy-blue text-white hover:opacity-90">
                    <Link to={item.to}>
                      Learn more
                      <ArrowRight className="h-4 w-4 ml-2" />
                    </Link>
                  </Button>
                  <Button
                    variant="outline"
                    className="border-bright-orange text-bright-orange hover:bg-orange-50"
                    onClick={goToBooking}
                  >
                    Get a Free Quote
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-10 text-center text-xs text-gray-500">Images are illustrative.</p>
      </div>
    </section>
  );
};
